import React from "react";
import "./styles/startup.css";
const StartUp = () => {
  return (
    <div className="startup-splash">
      <center>
      <h1>Hi!! I am Dhruv Gupta</h1>
      </center>
      <br />
      <p>Logging in</p><div className="spinner"></div>
    </div>
  );
};

export default StartUp;
